import React, { useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import cardData from "../data/Carddata";

  export default function MoreInfo(props){
    const paramId = props.match.params.id;
    const [title, setTitle] = useState();
    const [imgsrc, setImgSrc] = useState();
    const [content, setContent] = useState();

    useEffect(()=>{
      window.scrollTo(0, 0);
      cardData.filter(service=>service.id.toString()===paramId)
      .map(filteredService=>{
        return(
          setTitle(filteredService.title),
          setImgSrc(filteredService.imgsrc),
          setContent(filteredService.content) 
        )
      })
    })
    
    
    return (
      <span>
        <div className="p-3">
          <Breadcrumb tag="nav" listTag="div">
              <BreadcrumbItem tag="a" href="/">Home</BreadcrumbItem>
              <BreadcrumbItem tag="a" href="/services">Services</BreadcrumbItem>
              <BreadcrumbItem active tag="span">{title}</BreadcrumbItem>
          </Breadcrumb>
        </div>
        <div className="container">
          <Row>
          <Col lg={6}>
            <img alt="serviceImg"
            className="img-fluid rounded shadow float-left" width="100%"
            src={imgsrc}/> 
          </Col>
            
          <Col lg={6} className="divMoreinfo col-md-6 text-justify">
            <h1 align="center">{title}</h1>
            <p>{content}</p>
          </Col>
          </Row>
        </div>
        <br></br>
        </span>
    );
  };